import { render } from "./elecBoardForging.vue?vue&type=template&id=eb3398d4"
import script from "./elecBoardForging.vue?vue&type=script&lang=js"
export * from "./elecBoardForging.vue?vue&type=script&lang=js"

import exportComponent from "D:\\A_Projcets_Code\\mes-chunyu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__